import React, {useState} from 'react';
import {IFdOperatingCost, ISupplierUserProfile} from 'constants/interfaces';
import {
  List,
  ListItem,
  ListItemText,
  Box,
  ListItemSecondaryAction,
  Button,
  Typography,
} from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import {ESidePanelView} from 'constants/index';
import {OperatingCostSidePanelData} from 'screens/Dashboard/utils/SidePanel/SidePanel';
import {reduxToggleSidePanel} from 'appredux/actions';

const EditFdOperatingCosts = (props: {
  user: ISupplierUserProfile;
  applicationId: number;
  operatingCosts: IFdOperatingCost[];
}) => {
  const [operatingCosts] = useState(props.operatingCosts || []);

  const handleEdit = (operatingCost: IFdOperatingCost) => {
    const type = {
      panelType: ESidePanelView.EDIT_FD_OPERATING_COST,
      data: {
        applicationId: props.applicationId,
        operatingCost,
      } as OperatingCostSidePanelData,
    };
    reduxToggleSidePanel(true, type, false);
  };

  const handleAdd = () => {
    const type = {
      panelType: ESidePanelView.EDIT_FD_OPERATING_COST,
      data: {
        applicationId: props.applicationId,
      } as OperatingCostSidePanelData,
    };
    reduxToggleSidePanel(true, type, false);
  };

  return (
    <Box margin={'1rem'}>
      <Box marginLeft={1}>
        <Typography variant="subtitle2" gutterBottom>
          Operating Costs
        </Typography>
      </Box>
      <List>
        {operatingCosts
          .sort((a, b) => a.expense!.name!.localeCompare(b.expense!.name!))
          .map((cost) => (
            <ListItem key={cost.id} button onClick={() => handleEdit(cost)}>
              <Box display="flex" justifyContent="space-between" width="100%">
                <ListItemText primary={cost.expense?.name} />
                <ListItemSecondaryAction>
                  <ChevronRightIcon />
                </ListItemSecondaryAction>
              </Box>
            </ListItem>
          ))}
      </List>
      <Button variant="text" fullWidth onClick={handleAdd} color={'primary'}>
        Add
      </Button>
    </Box>
  );
};

export default EditFdOperatingCosts;
